// All mock data for the Baji-style site clone.
// Image URLs are from Baji's public CDN for visual fidelity to the reference design.

const CDN = "https://img.b112j.com/bj/h5/assets";
const activeIcon = (name) => `${CDN}/v3/images/icon-set/menu-type/active/icon-${name}.png`;

export const SPORTS_TABS = [
  { id: "cricket", label: "Cricket", icon: `${CDN}/v3/images/icon-set/sports-type/icon-exchange.svg` },
  { id: "fbsports", label: "FB Sports", icon: `${CDN}/v3/images/icon-set/sports-type/icon-fbsports.svg` },
  { id: "isports", label: "I-Sports", icon: `${CDN}/v3/images/icon-set/sports-type/icon-sportbook.svg` },
  { id: "sbo", label: "SBO Sports", icon: `${CDN}/v3/images/icon-set/sports-type/icon-sbov2.svg` },
  { id: "horsebook", label: "Horsebook", icon: `${CDN}/v3/images/icon-set/sports-type/icon-horsebook.svg` },
  { id: "bti", label: "BTi Sports", icon: `${CDN}/v3/images/icon-set/sports-type/icon-sbtech.svg` },
  { id: "ug", label: "UG Sports", icon: `${CDN}/v3/images/icon-set/sports-type/icon-ugv3.svg` },
  { id: "cmd", label: "CMD Sports", icon: `${CDN}/v3/images/icon-set/sports-type/icon-cmd.svg` },
  { id: "esports", label: "E-Sports", icon: `${CDN}/v3/images/icon-set/sports-type/icon-awcme1sport.svg` },
  { id: "pinnacle", label: "Pinnacle", icon: `${CDN}/v3/images/icon-set/sports-type/icon-awcmpinnacle.svg` },
  { id: "insports", label: "INSPORTS", icon: `${CDN}/v3/images/icon-set/sports-type/icon-nst.svg` },
];

const v = (name) => `${CDN}/v3/images/icon-set/vendor-type/for-dark/vendor-${name}.png`;

export const CASINO_VENDORS = [
  { id: "evo", label: "Evolution", icon: v("evo") },
  { id: "awcmpp", label: "Pragmatic Play", icon: v("awcmpp") },
  { id: "awcmsexy", label: "Sexy", icon: v("awcmsexy") },
  { id: "awcmpt", label: "Playtech", icon: v("awcmpt") },
  { id: "winfinity", label: "Winfinity", icon: v("winfinity") },
  { id: "bg", label: "Big Gaming", icon: v("bg") },
  { id: "mg", label: "Microgaming", icon: v("mg") },
  { id: "awcmhotroad", label: "HotRoad", icon: v("awcmhotroad") },
  { id: "awcmdg", label: "Dream Gaming", icon: v("awcmdg") },
  { id: "awcmvia", label: "Viacasino", icon: v("awcmvia") },
];

export const SLOT_VENDORS = [
  { id: "awcmjili", label: "JILI", icon: v("awcmjili") },
  { id: "pg", label: "PG Soft", icon: v("pg") },
  { id: "awcmpp", label: "Pragmatic Play", icon: v("awcmpp") },
  { id: "jdb", label: "JDB", icon: v("jdb") },
  { id: "awcmfc", label: "Fa Chai", icon: v("awcmfc") },
  { id: "awcmyesbingo", label: "Yellow Bat", icon: v("awcmyesbingo") },
  { id: "lucky365", label: "Lucky365", icon: v("lucky365") },
  { id: "awcmsg", label: "Spadegaming", icon: v("awcmsg") },
  { id: "awcmfastspin", label: "FastSpin", icon: v("awcmfastspin") },
  { id: "nextspin", label: "NextSpin", icon: v("nextspin") },
  { id: "mg", label: "Microgaming", icon: v("mg") },
  { id: "rich88", label: "Rich88", icon: v("rich88") },
  { id: "awcmpt", label: "Playtech", icon: v("awcmpt") },
  { id: "fiveg", label: "FiveG", icon: v("fiveg") },
  { id: "octoplay", label: "Octoplay", icon: v("octoplay") },
  { id: "yggdrasil", label: "Yggdrasil", icon: v("yggdrasil") },
  { id: "awcmrt", label: "Red Tiger", icon: v("awcmrt") },
  { id: "worldmatch", label: "WorldMatch", icon: v("worldmatch") },
  { id: "dragoonsoft", label: "Dragoonsoft", icon: v("dragoonsoft") },
  { id: "hacksaw", label: "Hacksaw", icon: v("hacksaw") },
];

export const CRASH_VENDORS = [
  { id: "jdbaspribe", label: "Spribe", icon: v("jdbaspribe") },
  { id: "awcmpp", label: "Pragmatic Play", icon: v("awcmpp") },
  { id: "awcmjili", label: "JILI", icon: v("awcmjili") },
  { id: "jdb", label: "JDB", icon: v("jdb") },
  { id: "smartsoft", label: "SmartSoft", icon: v("smartsoft") },
  { id: "awcmfc", label: "Fa Chai", icon: v("awcmfc") },
  { id: "awcmkm", label: "KingMidas", icon: v("awcmkm") },
  { id: "awcmyl", label: "You Lian", icon: v("awcmyl") },
  { id: "hacksaw", label: "Hacksaw", icon: v("hacksaw") },
  { id: "rich88", label: "Rich88", icon: v("rich88") },
];

export const TABLE_VENDORS = [
  { id: "awcmjili", label: "JILI", icon: v("awcmjili") },
  { id: "awcmkm", label: "KingMidas", icon: v("awcmkm") },
  { id: "jdbaspribe", label: "Spribe", icon: v("jdbaspribe") },
  { id: "rich88", label: "Rich88", icon: v("rich88") },
  { id: "worldmatch", label: "WorldMatch", icon: v("worldmatch") },
  { id: "pg", label: "PG Soft", icon: v("pg") },
  { id: "jdb", label: "JDB", icon: v("jdb") },
  { id: "yggdrasil", label: "Yggdrasil", icon: v("yggdrasil") },
  { id: "netent", label: "NetEnt", icon: v("netent") },
  { id: "hacksaw", label: "Hacksaw", icon: v("hacksaw") },
];

export const FISHING_VENDORS = [
  { id: "awcmjili", label: "JILI", icon: v("awcmjili") },
  { id: "jdb", label: "JDB", icon: v("jdb") },
  { id: "acewin", label: "AceWin", icon: v("acewin") },
  { id: "awcmfc", label: "Fa Chai", icon: v("awcmfc") },
  { id: "awcmyesbingo", label: "Yellow Bat", icon: v("awcmyesbingo") },
  { id: "awcmsg", label: "Spadegaming", icon: v("awcmsg") },
  { id: "awcmfastspin", label: "FastSpin", icon: v("awcmfastspin") },
  { id: "lucky365", label: "Lucky365", icon: v("lucky365") },
];

export const ARCADE_VENDORS = [
  { id: "jdb", label: "JDB", icon: v("jdb") },
  { id: "awcmfc", label: "Fa Chai", icon: v("awcmfc") },
  { id: "awcmyl", label: "You Lian", icon: v("awcmyl") },
  { id: "hacksaw", label: "Hacksaw", icon: v("hacksaw") },
  { id: "rich88", label: "Rich88", icon: v("rich88") },
  { id: "awcmkm", label: "KingMidas", icon: v("awcmkm") },
  { id: "awcmpp", label: "Pragmatic Play", icon: v("awcmpp") },
  { id: "pg", label: "PG Soft", icon: v("pg") },
];

export const LOTTERY_VENDORS = [
  { id: "awcmjili", label: "JILI", icon: v("awcmjili") },
  { id: "number", label: "Number", icon: v("number") },
  { id: "awcmyesbingo", label: "Yellow Bat", icon: v("awcmyesbingo") },
  { id: "awcmkm", label: "KingMidas", icon: v("awcmkm") },
  { id: "rich88", label: "Rich88", icon: v("rich88") },
  { id: "ugv3lottery", label: "UG", icon: v("ugv3lottery") },
];

export const EXCLUSIVE_GAMES = [
  { id: "aviator", title: "Aviator", img: `${CDN}/images/exclusivegames/default/exclusive-aviator.png`, tag: "Hot" },
  { id: "super-ace", title: "BJ Super Ace+", img: `${CDN}/images/exclusivegames/default/exclusive-bj-super-ace-plus.png`, tag: "New" },
  { id: "treasures-aztec", title: "Treasures of Aztec", img: `${CDN}/images/exclusivegames/default/exclusive-treasures-of-aztec.png` },
  { id: "fortune-gems", title: "Fortune Gems 500", img: `${CDN}/images/exclusivegames/default/exclusive-fortune-gems-500.png`, tag: "Top" },
  { id: "fortune-garuda", title: "Fortune Garuda 500", img: `${CDN}/images/exclusivegames/default/exclusive-fortune-garuda-500.png` },
  { id: "fortune-rabbit", title: "Fortune Rabbit", img: `${CDN}/images/exclusivegames/default/exclusive-fortune-rabbit.png` },
  { id: "money-wheel", title: "Money Wheel", img: `${CDN}/images/exclusivegames/default/exclusive-money-wheel.png` },
  { id: "boxing-king", title: "Boxing King", img: `${CDN}/images/exclusivegames/default/exclusive-boxing-king.png`, tag: "Hot" },
  { id: "divas-ace", title: "Diva's Ace", img: `${CDN}/images/exclusivegames/default/exclusive-divas-ace.png`, tag: "New" },
  { id: "super-ace-deluxe", title: "Super Ace Deluxe", img: `${CDN}/images/exclusivegames/default/exclusive-super-ace-deluxe.png` },
  { id: "money-coming", title: "Money Coming", img: `${CDN}/images/exclusivegames/default/exclusive-money-coming.png` },
];

export const SPONSORS = [
  { id: "sunrisers", name: "Sunrisers Eastern Cape", role: "Title Sponsor 2023 - 2024", img: `${CDN}/v3/images/sponsor/sunrisers-eastern-cape.png` },
  { id: "deccan", name: "Deccan Gladiators", role: "Title Sponsor 2023 - 2024", img: `${CDN}/v3/images/sponsor/deccan-gladiators.png` },
  { id: "patriots", name: "St Kitts & Nevis Patriots", role: "Principle Sponsor 2024 - 2025", img: `${CDN}/v3/images/sponsor/st-kitts-and-nevis-patriots.png` },
  { id: "biratnagar", name: "Biratnagar Kings", role: "Back of Jersey Sponsor 2024 - 2025", img: `${CDN}/v3/images/sponsor/biratnagar-kings.png` },
];

export const AMBASSADORS = [
  {
    id: "kp",
    name: "Kevin Pietersen",
    year: "2024 - 2026",
    role: "Cricket Legend",
    img: `${CDN}/v3/images/ambassador/kevin-pietersen.png`,
    photo:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/8/86/Kevin_Pietersen_2014.jpg/330px-Kevin_Pietersen_2014.jpg",
  },
  {
    id: "amy",
    name: "Amy Jackson",
    year: "2023 - 2024",
    role: "Cinema Star",
    img: `${CDN}/v3/images/ambassador/amy-jacson.png`,
    photo:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/Amy_Jackson_graces_the_Moet_N_Chandon_bash_at_F_bar_01.jpg/330px-Amy_Jackson_graces_the_Moet_N_Chandon_bash_at_F_bar_01.jpg",
  },
  {
    id: "hansika",
    name: "Hansika Motwani",
    year: "2023 - 2024",
    role: "Cinema Star",
    img: `${CDN}/v3/images/ambassador/hansika.png`,
    photo:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/fd/Hansika_Motwani_at_HELLO%21_Hall_of_Fame_Awards_2023_%281%29_%28cropped%29.jpg/330px-Hansika_Motwani_at_HELLO%21_Hall_of_Fame_Awards_2023_%281%29_%28cropped%29.jpg",
  },
  {
    id: "wasim",
    name: "Wasim Akram",
    year: "2024 - 2028",
    role: "Cricket Legend",
    img: `${CDN}/v3/images/ambassador/wasim-s.svg`,
    photo:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/f/f4/Wasim-akram-gesf-2018-7878.jpg/330px-Wasim-akram-gesf-2018-7878.jpg",
  },
  {
    id: "keya",
    name: "Keya Akter Payel",
    year: "2025",
    role: "Lifestyle Icon",
    img: `${CDN}/v3/images/ambassador/keya-akter-payel.png`,
    photo:
      "https://customer-assets.emergentagent.com/job_website-control-hub/artifacts/ifbhgqp8_images.jpeg",
  },
  {
    id: "yesha",
    name: "Yesha Sagar",
    year: "2025 - 2026",
    role: "Lifestyle Icon",
    img: `${CDN}/v3/images/ambassador/yesha-sagar.png`,
    photo:
      "https://upload.wikimedia.org/wikipedia/commons/thumb/0/09/Yesha_Rughani_2K19.jpg/330px-Yesha_Rughani_2K19.jpg",
  },
];

// Mock promotion banners - we'll generate these via CSS gradients
export const PROMOTIONS = [
  {
    id: "welcome",
    title: "100% Welcome Bonus",
    subtitle: "Up to ৳20,000 on your first deposit",
    cta: "Claim Now",
    color1: "#1ba055",
    color2: "#0a3a22",
    badge: "NEW",
  },
  {
    id: "ipl",
    title: "IPL Cashback Festival",
    subtitle: "Daily 5% cashback on all cricket bets",
    cta: "Bet Now",
    color1: "#b8842a",
    color2: "#4a2d10",
    badge: "HOT",
  },
  {
    id: "casino",
    title: "Live Casino Rebate",
    subtitle: "Earn up to 1% rebate every day",
    cta: "Play Live",
    color1: "#7c3aed",
    color2: "#3b1772",
    badge: "VIP",
  },
  {
    id: "slot",
    title: "Slots Mega Tournament",
    subtitle: "৳5,000,000 prize pool every week",
    cta: "Join Tournament",
    color1: "#ef4444",
    color2: "#7a1e1e",
    badge: "EVENT",
  },
];

export const SIDE_MENU = [
  { id: "exclusive", label: "Exclusive Games", icon: activeIcon("logo"), to: "/" },
  { id: "sports", label: "Sports", icon: activeIcon("sport"), to: "/sports" },
  { id: "casino", label: "Casino", icon: activeIcon("casino"), to: "/casino" },
  { id: "slots", label: "Slots", icon: activeIcon("slot"), to: "/slots" },
  { id: "crash", label: "Crash", icon: activeIcon("crash"), to: "/crash" },
  { id: "table", label: "Table", icon: activeIcon("table"), to: "/table" },
  { id: "fishing", label: "Fishing", icon: activeIcon("fish"), to: "/fishing" },
  { id: "favourite", label: "Favourite", icon: "", to: "/favourite" },
  { id: "lottery", label: "Lottery", icon: activeIcon("lottery"), to: "/lottery" },
];

export const SECONDARY_MENU = [
  { id: "promotions", label: "Promotions", to: "/promotions" },
  { id: "vip", label: "VIP Club", to: "/vip" },
  { id: "referral", label: "Referral program", to: "/referral" },
  { id: "affiliate", label: "Affiliate", to: "/contact" },
  { id: "ambassador", label: "Brand Ambassadors", to: "/ambassadors" },
  { id: "app", label: "APP Download", to: "/app-download" },
  { id: "contact", label: "Contact Us", to: "/contact" },
];

export const ANNOUNCEMENTS = [
  "Welcome to Maxlive88 — Play Smart, Win Big.",
  "Dear customers, please use the official link to access our website.",
  "Download the Maxlive88 App for the smoothest mobile betting experience.",
  "100% Welcome Bonus is live for new sign-ups — claim it on your first deposit.",
];

// Generate mock games for category pages
export const generateMockGames = (categoryId, count = 24) => {
  const titles = [
    "Lucky Dragon", "Golden Empire", "Crazy 777", "Money Heist", "Royal Fortune",
    "Aztec Magic", "Dragon Tiger", "Mega Roulette", "Cosmic Spins", "Phoenix Rising",
    "Pirate Treasure", "Wild Buffalo", "Diamond Strike", "Aviator", "Mines",
    "Sweet Bonanza", "Gates of Olympus", "Big Bass", "Starburst", "Book of Dead",
    "Hot Hot Fruit", "Crystal Cave", "Tiger Spin", "Golden Genie",
  ];
  return titles.slice(0, count).map((title, i) => ({
    id: `${categoryId}-${i}`,
    title,
    rtp: (95 + Math.random() * 4).toFixed(2),
    hot: i % 5 === 0,
    new: i % 7 === 0,
  }));
};
